import { getHoseAssemblyDetails } from 'components/availability-wrapper/utils';
import { useTranslations } from 'next-intl';
import { hoseAssemblyDetailsCompType } from './types';

export const HoseAssemblyDetails = ({
  hoseAvailabilityLabel
}: hoseAssemblyDetailsCompType) => {
  const t = useTranslations();
  return (
    <p className="cat-u-theme-typography-footnote">
      {t(getHoseAssemblyDetails(hoseAvailabilityLabel))}
    </p>
  );
};
